export default __webpack_public_path__ + "static/images/learn-promo.a51415e30679fc80c2f1643f4743a67f.jpg";